import type { UpdateMutationResult } from "@/customTypings/api/UpdateMutation";
import type {
    MunicipalDegradableUpdatePayload,
    IMunicipalDegradableDetail,
} from "@/customTypings/reference/MunicipalDegradable";
import { authHeader, handleResponse } from "../../utils";
import { appendIncludeAuditQuery, type DetailGetByIdOptions } from "@/utils/api/detailGetOptions";

export const municipalDegradablesService = {
    getById,
    update,
    disable,
    enable,
};

function getById(id: string, options?: DetailGetByIdOptions) {
    const requestOptions: RequestInit = {
        method: "GET",
        headers: authHeader(),
        credentials: "include",
    };
    return fetch(
        appendIncludeAuditQuery(`/api/referencedata/municipal-degradables/${encodeURIComponent(id)}`, options),
        requestOptions
    ).then(handleResponse) as Promise<IMunicipalDegradableDetail>;
}

function update(payload: MunicipalDegradableUpdatePayload) {
    const requestOptions: RequestInit = {
        method: "POST",
        headers: authHeader(),
        credentials: "include",
        body: JSON.stringify(payload),
    };
    return fetch(`/api/referencedata/municipal-degradables/update`, requestOptions).then(
        handleResponse
    ) as Promise<UpdateMutationResult<IMunicipalDegradableDetail>>;
}

function disable(id: string) {
    return postQuery("disable", id);
}

function enable(id: string) {
    return postQuery("enable", id);
}

function postQuery(action: string, id: string) {
    const requestOptions: RequestInit = {
        method: "POST",
        headers: authHeader(),
        credentials: "include",
    };
    return fetch(
        `/api/referencedata/municipal-degradables/${action}?id=${encodeURIComponent(id)}`,
        requestOptions
    ).then(handleResponse);
}
